import { GqlGetCurrentUser, type GetCurrentUserQuery } from "#gql";

type CurrentUser = GetCurrentUserQuery["currentUser"];

type AuthenticationError = {
	status: number;
	message: string;
};

export const useAppUserStore = defineStore("appUser", () => {
	const isResquesting = ref(false);
	const wasAuthenticated = ref(false);

	const error = ref<AuthenticationError | null>(null);

	const hasError = computed(() => error.value !== null);
	const isError401 = computed(() => error.value?.status === 401);
	const isError403 = computed(() => error.value?.status === 403);

	const currentUser = ref<CurrentUser | null>(null);

	async function getCurrentUser() {
		try {
			isResquesting.value = true;
			const response = await GqlGetCurrentUser();

			console.log("GqlGetCurrentUser response: ", response);

			if (response) {
				currentUser.value = response.currentUser;
				wasAuthenticated.value = true;
				error.value = null;
			}
		}
		catch (e: any) {
			console.error("GqlGetCurrentUser error: ", e);

			currentUser.value = null;
			wasAuthenticated.value = false;
			error.value = {
				status: e.statusCode,
				message: e.message,
			};
		}
		finally {
			isResquesting.value = false;
		}
	}

	return {
		isResquesting,
		wasAuthenticated,
		currentUser,
		hasError,
		isError401,
		isError403,
		getCurrentUser,
	};
});

// make sure to pass the right store definition, `useAuth` in this case.
if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useAppUserStore, import.meta.hot));
}
